<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Manual Reversal</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <ManualReversalForm />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import ManualReversalForm from "../../components/Kleyton/Forms/FundsTransfer/Revesal/ManualReversalForm";

export default {
  name: "ManualReversal",
  page: {
    title: "Funds Transfer",
    meta: [{ name: "Funds Transfer", content: window.__env.app.description }]
  },
  components: {
    ManualReversalForm,
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "ManualReversal",
      title: "Manual Reversal",
      items: [
        {
          text: "Transaction",
          href: "/"
        },
        {
          text: "Manual Reversal",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
